import Main from 'components/Main';

import ContentBlock from "components/ContentBlock";
import ButtonIconSelect from "components/ButtonIconSelect";

import './index.less';
import './themes/default.less';

export default class SMS extends Main {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            paymentWays: []
        };
    }

    componentDidMount() {
        this.refresh();
    }

    async refresh() {
        this._helper.showLoading();
        const resp = await this._request.paymentWay.getAll();
        let paymentWays = (resp?.data || []);
        this._helper.hideLoading();

        this.setState({ paymentWays });
    }

    async addPaymentWay(info) {
        this._helper.showLoading();
        await this._request.paymentWay.add(info);
        this._helper.hideLoading();
        localStorage.setItem('cacheData', '');

        this.refresh();
    }

    async addPaymentWayToClinic(info) {
        const { paymentWays } = this.state;
        const { paymentWayId } = info;
        const { currentClinicId } = this.props;
        info.domainId = currentClinicId;
        const row = paymentWays.find(it => it.id === paymentWayId);
        if (row) {
            const { paymentWaysHasBranchesList } = row;
            if (!paymentWaysHasBranchesList.some(it => it.domainId === currentClinicId)) {
                this._helper.showLoading();
                await this._request.paymentWayBranch.add(info);
                this._helper.hideLoading();
                this._helper.showNotifyPopup({
                    type: "success",
                    label: "Успешно",
                    text: "Добавлен новый вид платежа",
                });


            } else {
                this._helper.showNotifyPopup({
                    type: "error",
                    label: "Ошибка сохранения",
                    text: "Данный вид платежа уже привязан к клинике",
                });
            }
        }
        localStorage.setItem('cacheData', '');

        this.refresh();
    }

    deleteConfirmPaymentWay(id) {
        const { paymentWays } = this.state;
        const { currentClinicId } = this.props;
        const row = paymentWays.find(it => it.id === id);
        const paymentWay = row.paymentWaysHasBranchesList.find(it => it.domainId === currentClinicId);
        this._helper.confirm(
            { title: "Удаление записи", message: this.tr("Вы удаляете запись из списка - Подтвердить?") },
            this.deletePaymentWayFromClinic.bind(this, paymentWay.id)
        );
    }

    async deletePaymentWayFromClinic(id) {
        this._helper.showLoading();
        await this._request.paymentWayBranch.delete(id);
        this._helper.hideLoading();
        localStorage.setItem('cacheData', '');

        this.refresh();
    }

    openAddPaymentWayDialog() {
        this._helper.openDialog("addPaymentWay", this.addPaymentWay.bind(this));
    }

    openAddPaymentWayToClinicDialog() {
        const { paymentWays } = this.state;
        const { currentClinicId } = this.props;
        const currentClinic = this._helper.getClinicNameById(currentClinicId);
        this._helper.openDialog("addPaymentWayToClinic", { paymentWays, currentClinic }, this.addPaymentWayToClinic.bind(this));
    }

    render() {
        const { paymentWays } = this.state;
        const { currentClinicId } = this.props;
        const currentClinic = this._helper.getClinicNameById(currentClinicId);

        return (
            <div className="paymentWay flex flex1 gap16">
                <div>
                    <ContentBlock
                        title={`Список существующих оплат`}
                        icon={{
                            name: "plus",
                            tooltip: "Список способа оплат",
                            onClick: this.openAddPaymentWayDialog.bind(this)
                        }}
                    >
                        <div>
                            {paymentWays.map((it, i) => (<div className="paymentWayRow text p1 hand" key={"paymentWayRow" + i}>
                                {it.name}
                            </div>))}
                        </div>

                    </ContentBlock>
                </div>
                <div>
                    <ContentBlock
                        title={`Список способа оплат для клиники ${currentClinic}`}
                        icon={{
                            name: "plus",
                            tooltip: "Список способа оплат",
                            onClick: this.openAddPaymentWayToClinicDialog.bind(this)
                        }}
                    >
                        <div>
                            {paymentWays.filter(it => it.paymentWaysHasBranchesList.some(br => br.domainId === currentClinicId))
                                .map((it, i) => (<div className="paymentWayRow text p1 hand flex between" key={"paymentWayRow" + i}>
                                    {it.name}
                                    <div>
                                        <ButtonIconSelect
                                            name="dots"
                                            translate={true}
                                            stopEvent={true}
                                            items={[{ name: "Удалить", onClick: this.deleteConfirmPaymentWay.bind(this, it.id) }]}
                                        />
                                    </div>
                                </div>))}
                        </div>

                    </ContentBlock>
                </div>

            </div>
        );
    }
}

